<template>
  <el-form :model="configurations" label-width="220px" ref="configurationForm"
           v-loading="page_loading">
    <template v-for="(configuration, key) in configurations">
      <el-form-item :label="configuration.name" :prop="key" :key="key">
        <el-input v-model="configurations[key].value"
                  v-if="['Number', 'Text'].indexOf(configuration.type) > -1"></el-input>
        <el-radio-group v-model="configurations[key].value" v-if="configuration.type == 'Radio'">
          <el-radio v-for="(label, value) in configuration.options" :label="value" :key="value">{{ label }}</el-radio>
        </el-radio-group>
        <el-checkbox v-model="configurations[key].value" v-if="configuration.type == 'Boolean'"></el-checkbox>
        <el-upload
            v-if="configuration.type == 'Image'"
            action="-"
            class="el-uploader"
            style="--image-width: 200px;--image-height: 200px"
            :show-file-list="false"
            :http-request="(source) => handleImageUpload(key, source)">
          <img v-if="configuration.value" :src="configuration.value" class="el-uploader-image">
          <i v-else class="el-icon-plus el-uploader-icon"></i>
          <div class="el-upload__tip" slot="tip">只能上传image文件</div>
        </el-upload>
        <template v-if="configuration.type == 'AsArray'">
          <el-input v-for="(item, index) in configurations[key].value" :key="index"
                    v-model="configurations[key].value[index]"
                    style="width: 200px;margin-right: 10px;margin-bottom: 10px;">
            <template slot="append">
              <span @click="removeValueItem(key, index)" style="cursor: pointer;">删</span>
            </template>
          </el-input>
          <el-button icon="el-icon-circle-plus-outline" @click="addValueItem(key)"></el-button>
        </template>
        <template v-if="configuration.description">
          <div class="el-form-tip">{{ configuration.description }}</div>
        </template>
      </el-form-item>
    </template>
    <div class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button @click="submit('configurationForm')" type="primary">确 定</el-button>
    </div>
  </el-form>
</template>

<script>
import {systemConfigAll, systemConfigStore} from "@/api/system"
import {uploadImage} from "@/api/common"

export default {
  name: "SystemConfig",
  props: {
    group: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      configurations: null,
      page_loading: false,
    }
  },
  created() {

  },
  mounted() {
    this.getSystemConfig()
  },
  methods: {
    getSystemConfig() {
      let that = this
      systemConfigAll(that.group).then(res => {
        that.configurations = res
      })
    },
    cancel() {
      this.$emit('cancel')
    },
    addValueItem(key) {
      this.configurations[key].value.push('')
    },
    removeValueItem(key, index) {
      this.configurations[key].value.splice(index, 1)
    },
    handleImageUpload(key, source) {
      let that = this
      uploadImage('book', source.file).then(res => {
        that.configurations[key].value = res.url
      })
    },
    submit() {
      let that = this
      that.page_loading = true
      let data = {}
      for (let key in that.configurations) {
        data[key] = that.configurations[key].value
      }
      systemConfigStore(data).then(() => {
        that.page_loading = false
        that.$message.success('操作成功')
        setTimeout(() => {
          that.getSystemConfig()
        }, 500)
      }).catch(() => {
        that.page_loading = false
      })
    },
  },
}
</script>

<style scoped>

</style>